import api from "./api";

// Create Support Ticket
export const createSupportTicket =
    async (formData) => {
        try {
            const response =
                await api.post(
                    "/support-ticket/create",
                    formData,
                    {
                        headers: {
                            "Content-Type":
                                "multipart/form-data",
                        },
                    }
                );

            if (
                response.status === 200
            ) {
                return response.data;
            }

            return {
                error:
                    "Failed to create support ticket",
            };
        } catch (error) {
            return {
                error:
                    error.response?.data
                        ?.detail ||
                    error.message,
            };
        }
    };

// Get My Support Tickets
export const getMySupportTickets =
    async (
        page = 1,
        size = 10
    ) => {
        try {
            const response =
                await api.get(
                    `/support-ticket/me?page=${page}&size=${size}`
                );

            if (
                response.status === 200
            ) {
                return response.data;
            }

            return {
                error:
                    "Failed to fetch support tickets",
            };
        } catch (error) {
            return {
                error:
                    error.response?.data
                        ?.detail ||
                    error.message,
            };
        }
    };